export default __webpack_public_path__ + "static/media/file-word-resized.161404e9.svg";